'use client'

import Image, { StaticImageData } from 'next/image'
import { FC, PropsWithChildren } from 'react'
import GridContainer from '../GridContainer'

interface ImageFirstSectionProps extends PropsWithChildren {
  imageSrc: StaticImageData
  imageAltText: string
  backgroundColor?: 'default' | 'green' | 'darkGreen'
  imageWidth?: 'default' | 'wide'
}

const ImageFirstSection: FC<ImageFirstSectionProps> = ({
  imageSrc,
  imageAltText,
  children,
  backgroundColor = 'default',
  imageWidth = 'default',
}) => {
  let bgClass = 'bg-ink-200'
  if (backgroundColor === 'green') bgClass = 'bg-green-700'
  if (backgroundColor === 'darkGreen') bgClass = 'bg-green-900'

  return (
    <div className={`py-16 md:py-24 ${bgClass}`}>
      <GridContainer>
        <div
          className={`
            mb-6 md:mb-0
            rounded-[12px] md:rounded-[16px] overflow-hidden
            col-span-full ${imageWidth === 'wide' ? 'md:col-span-7' : 'md:col-span-6'}
          `}
        >
          {imageWidth === 'wide' ? (
            <div className="relative w-full aspect-[1] md:aspect-[1.3]">
              <Image src={imageSrc} alt={imageAltText} priority fill className="object-cover" />
            </div>
          ) : (
            <div className="relative w-full aspect-[1]">
              <Image src={imageSrc} alt={imageAltText} priority fill />
            </div>
          )}
        </div>
        <div
          className={`
          flex flex-col md:justify-center
          col-span-full ${
            imageWidth === 'wide' ? 'md:col-start-9 md:col-span-4' : 'md:col-start-8 md:col-span-5'
          }
        `}
        >
          {children}
        </div>
      </GridContainer>
    </div>
  )
}

export default ImageFirstSection
